import { h } from 'preact';
import Store from 'store/store';
import * as BaseComp from 'components/pages/home/home.js';
import { accessNested, getStylingImagePath } from 'utils/utils';
import s from 'components/pages/home/home.sss';

export default class Home extends BaseComp.default {

	getTitleTreatment(copy, imageRoot, pageData) {
		const base = super.getTitleTreatment();

		const { device, deviceSize, orientation } = accessNested(Store.get(), 'client');

		if ((device === 'ipad' || deviceSize === 'mobile') && orientation === 'landscape') {
			const imgRoot = accessNested(this.props, 'appData.urls.roots.imageRegion') || '';
			const ttPath = getStylingImagePath(this.props.appData, 'tt3', imgRoot + '/' + 'tt3.png');
			let props = this.props || {};
			copy = copy || props.appData.copy;
			imageRoot = imageRoot || props.appData.urls.roots.imageRegion;
			pageData = pageData || props.pageData;
			let src = ttPath;
			let img = (
				<h1 class={s.titleText} id="titleText">
					<img
						ref={e => (this.$tt = e)}
						alt={copy.$HOME_TITLE_TREATMENT_SEO || 'Movie title'}
						class={s.title}
						src={src}
					/>
					<span>{copy.$HOME_TITLE_TREATMENT_SEO}</span>
				</h1>
			);
		
			return img;
		} else {
			return base;
		}
	}

}

export const verticallyCenter = BaseComp.verticallyCenter;
export const dependencies = BaseComp.dependencies;
